import * as Common from "../../commons/common"

export class Sheet {
  id: number
  sheet_group_key: number
  nendo: number
  grade: number
  page_count: number
  kind: number
  allot: number
  name: string
  subject_id: number
  subject_name: string
  field_names_completed: boolean
  corretct_image_completed: boolean

  constructor(sheet: any){
    this.id = sheet.id;
    this.sheet_group_key = sheet.sheet_group_key;
    this.nendo = sheet.nendo;
    this.grade = sheet.grade;
    this.page_count = sheet.page_count;
    this.kind = sheet.kind;
    this.allot = sheet.allot;
    this.name = sheet.name;
    this.subject_id = sheet.subject_id;
    this.subject_name = sheet.subject_name;
    this.field_names_completed = sheet.field_names_completed;
    this.corretct_image_completed = sheet.corretct_image_completed;
  }
}

export class SheetField {
  id: number
  sheet_id: number
  kind: number
  page: number
  part1: string
  part2: string
  part3: string
  allot: string
  partial_scorable: boolean
  correct_text: string = null
  scoring_type: number

  constructor(sheet_field: any){
    this.id = sheet_field.id;
    this.sheet_id = sheet_field.sheet_id;
    this.kind = sheet_field.kind;
    this.page = sheet_field.page;
    this.part1 = sheet_field.part1;
    this.part2 = sheet_field.part2;
    this.part3 = sheet_field.part3;
    this.allot = sheet_field.allot;
    this.partial_scorable = sheet_field.partial_scorable;
    this.correct_text = sheet_field.correct_text ? sheet_field.correct_text : null;
    this.scoring_type = sheet_field.scoring_type;
  }
}

export class ImageItem{
  pageNo: number
  base64Image: string
  baseWidth: number
  baseHeight: number
  angle: number = 0

  constructor(imageItem: any){
    this.pageNo = imageItem.pageNo;
    this.baseWidth = imageItem.baseWidth;
    this.baseHeight = imageItem.baseHeight;
    this.base64Image = imageItem.base64Image;
  }
}